import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTextAccordionItemComponent } from "./ds-text-accordion-item.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsTextAccordionItemComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsTextAccordionItemComponent],
})
export class DsTextAccordionItemModule {}
